import { DASHBOARD } from './Dash';
import { PROJECT_DASHBOARD } from './ProjectDash';
import { COMMENT_HISTORY } from './CommentHistory';

const BenchmarkText = {
  VIEW_DETAILS_LINK: 'View Details',
};

const MetricsText = {
  BY_AUTHOR_TOOLTIP:
    'Metrics based on {pullRequestName} the selected user(s) authored',
  BY_REVIEWER_TOOLTIP:
    'Metrics based on {pullRequestName} the selected user(s) reviewed',
  INSUFFICIENT_DATA_WITH_FILTERS_BANNER: `It looks like we don't have enough {pullRequestName} data to display for your currently selected filters. Try selecting a different range, user, or project.`,
  INSUFFICIENT_DATA_FOR_ORG_BANNER: `It looks like this
  organization doesn’t have any {pullRequestName} data to
  display yet. Check back once you have at least 1 {pullRequestName}.`,
};

const AppLevelText = {
  INTERNET_ON: 'Internet connection restored',
  INTERNET_OFF: 'No internet connection',
};

const DisplayText = {
  INSUFFICIENT_DATA: 'Insufficient Data',
  BENCHMARK: BenchmarkText,
  METRIC: MetricsText,
  APP: AppLevelText,
  DASHBOARD,
  PROJECT_DASHBOARD,
  COMMENT_HISTORY,
};

export default DisplayText;
